import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { Toolbar as MuiToolbar, ToolbarGroup } from 'material-ui/Toolbar';
import { SaveButton } from 'admin-on-rest';

const styles = {
  mobileToolbar: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: 'rgb(183, 28, 28)',
    justifyContent: 'flex-end',
    zIndex: 2,
  },
};

const valueOrDefault = (value, defaultValue) =>
  typeof value === 'undefined' ? defaultValue : value;

const Toolbar = ({
  invalid,
  submitOnEnter,
  handleSubmitWithRedirect,
  children,
}) => (
  <MuiToolbar style={styles.mobileToolbar} noGutter>
    <ToolbarGroup>
      {Children.count(children) === 0 ? (
        <SaveButton
          handleSubmitWithRedirect={handleSubmitWithRedirect}
          invalid={invalid}
          raised
          primary={false}
          submitOnEnter={submitOnEnter}
        />
      ) : (
        Children.map(
          children,
          (button) =>
            button
              ? React.cloneElement(button, {
                invalid,
                handleSubmitWithRedirect,
                raised: false,
                submitOnEnter: valueOrDefault(
                  button.props.submitOnEnter,
                  submitOnEnter
                ),
              })
              : null
        )
      )}
    </ToolbarGroup>
  </MuiToolbar>
);

Toolbar.propTypes = {
  children: PropTypes.node,
  handleSubmitWithRedirect: PropTypes.func,
  invalid: PropTypes.bool,
  submitOnEnter: PropTypes.bool,
};

Toolbar.defaultProps = {
  submitOnEnter: true,
};

export default Toolbar;
